import React from "react";
import axios from "axios";

async function SignOut() {
  await signOutKerjasamaBu();
  await signOutPendapatanLainLain();
  await signOutKpuUso();
  await signOutJasaPerbankan();
  await resetToken();
}

async function signOutPendapatanLainLain() {
  var credential = JSON.parse(localStorage.getItem("pendapatan_lain_lain"));
  if (credential) {
    return fetch(
      process.env.REACT_APP_HOST_PENDAPATAN_LAIN_LAIN + "/api/sso/signout",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: credential["token"] }),
      }
    ).then((data) => data.json());
  }
}

async function signOutKpuUso() {
  var credential = JSON.parse(localStorage.getItem("kpu_uso"));
  if (credential) {
    return fetch(process.env.REACT_APP_HOST_KPU_USO + "/api/sso/signout", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ token: credential["token"] }),
    }).then((data) => data.json());
  }
}

async function signOutJasaPerbankan() {
  var credential = JSON.parse(localStorage.getItem("jasa_perbankan"));
  if (credential) {
    return fetch(
      process.env.REACT_APP_HOST_JASA_PERBANKAN + "/api/sso/signout",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token: credential["token"] }),
      }
    ).then((data) => data.json());
  }
}

async function signOutKerjasamaBu() {
  var credential = JSON.parse(localStorage.getItem("kerjasama_bu"));
  return fetch(
    process.env.REACT_APP_HOST_KERJASAMA_BU +
    "/api/sso/signout?" + new URLSearchParams({
      token: credential["token"],
    }).toString(),
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

async function resetToken() {
  const params = {
    session: localStorage.getItem("client_id"),
  };

  return fetch(
    process.env.REACT_APP_HOST_CLOUD_PENDAPATAN +
    "/api/portal/post-data-logout",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    }
  ).then((data) => data.json());
}

export default SignOut;
